import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AlertService } from 'app/core';
import { TimeSheetService } from '../../time-sheet.service';
import { IReconciliationTotal, ITimeSheet } from '../../time-sheets.type';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseComponent } from 'app/pilotpay/base.component';
import * as moment from 'moment';

@Component({
	selector: 'app-time-sheet-card',
	templateUrl: './time-sheet-card.component.html',
	styleUrls: ['./time-sheet-card.component.scss']
})
export class TimeSheetCardComponent extends BaseComponent implements OnInit {
	constructor(
		protected alertService: AlertService,
		private router: Router,
		private timeSheetService: TimeSheetService
	) {
		super(alertService);
	}

	@Input() employeeId: number;
	public timeSheet: ITimeSheet;
	public dueDate: number;
	public totalTrips: IReconciliationTotal;

	public ngOnInit(): void {
		this.getTimeSheet(this.employeeId, moment.utc().format('YYYY-MM-DDTHH:mm:ss'));
	}

	public getTimeSheet(employeeId: number, date: string): void {
		this.timeSheetService.getCurrentTimeSheet(employeeId, date).subscribe(
			(timeSheet: ITimeSheet) => {
				this.timeSheet = timeSheet;
				this.totalTrips = this.timeSheet.totals.totalReconciliation.find(item => item.displayName === 'Trips');
				const currentDate: moment.Moment = moment().utc(true);
				const lockOutDate: any = moment(this.timeSheet.startDate)
					.add(1, 'month')
					.add(this.timeSheet.timeSheetLockOutDay - 1, 'day')
					.utc(true);
				this.dueDate = lockOutDate.diff(currentDate, 'days');
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public navigate(employeeId: number): void {
		this.router.navigate(['/pilotpay/time-sheets', employeeId], {
			queryParams: { date: this.timeSheet.startDate }
		});
	}
}
